module.exports = __webpack_public_path__ + "img/banner_googleplay.0833a75c.png";